import { render, staticRenderFns } from "./OrderMetalComponentsDisabled.vue?vue&type=template&id=c56e772a&"
import script from "./OrderMetalComponentsDisabled.vue?vue&type=script&lang=js&"
export * from "./OrderMetalComponentsDisabled.vue?vue&type=script&lang=js&"
import style0 from "./OrderMetalComponentsDisabled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports